import React, { useMemo } from "react";
import MeasurementBar from "./MeasurementBar";
import clsx from "clsx";
import { Box, Chip } from '@curves/ui-base';
import { formatVal, isEmpty } from "@Util/utils";

const MeasurementItem = ({ className, name, value = 0, unit, minValue = 0, maxValue = 99, normalRange = [], deltaValue = 0, percentage }) => {
	const isDisplayBar = normalRange.length > 0;

	const deltaSection = useMemo(
		() =>
			!isEmpty(deltaValue) ? (
				<Box>
					<Chip color="info" size="small" label={formatVal(deltaValue)} />
				</Box>
			) : null, // eslint-disable-next-line
		[deltaValue],
	);

	const barValue = percentage !== undefined ? percentage : value;

	return (
		<div className={clsx("measurement-item", isDisplayBar ? "measurement-item--with-bar" : "measurement-item--no-bar", className)}>
			<h5 className="measurement-item-title">{name}</h5>
			<div className="measurement-item__wrap">
				<div className="measurement-item__value measurement-item__value--normal">
					{value}
					{unit && <span className="measurement-item__value-unit">{unit}</span>}
					{deltaSection}
				</div>
				{isDisplayBar && <MeasurementBar value={barValue} normalRange={normalRange} minValue={minValue} maxValue={maxValue} showLabels />}
			</div>
		</div>
	);
};

export default MeasurementItem;
